import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
} from '@angular/core';
import { ListComponent } from 'src/app/ui-kit/list/list/list.component';
import { RenderHtmlDirective } from 'src/app/core/directives/render-html.directive';

export interface DataDisplayItem {
  label?: string;
  value?: string | number | null | undefined;
  /**
   * Whether the value should be rendered as HTML
   * Uses the appRenderHtml directive for safe HTML rendering
   * @default false
   */
  isHtml?: boolean;
  /**
   * Whether the value text should be bold
   * @default true
   */
  bold?: boolean;
  /**
   * Layout orientation for the label-value pair
   * - 'horizontal': Label and value on the same line (default)
   * - 'vertical': Label above value, stacked layout
   * @default 'horizontal'
   */
  orientation?: 'vertical' | 'horizontal';
}

@Component({
  selector: 'app-data-display-list',
  templateUrl: './data-display-list.component.html',
  styleUrls: ['./data-display-list.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, ListComponent, RenderHtmlDirective],
  host: {
    class: 'block',
  },
})
export class DataDisplayListComponent implements OnInit {
  readonly items = input<DataDisplayItem[]>([]);
  readonly divide = input<boolean>(true);

  constructor() {}

  ngOnInit() {}
}
